import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({
      activeBudgets: 'budgets/active',
      activeManagedBudgets: 'budgets/activeManaged',
      budgets: 'budgets/budgets',
      inactiveBudgets: 'budgets/inactive',
      masterBudget: 'budgets/masterBudget',
      myPendingRequests: 'requests/myPending',
      myProcessedRequests: 'requests/myProcessed',
      myRequests: 'requests/my',
      pendingRequests: 'requests/pending',
      processedRequests: 'requests/processed',
    }),
    ...mapGetters([
      'billing',
      'categories',
      'currentUser',
      'currentUserId',
      'currentRole',
      'doesManageMaster',
      'isAdmin',
      'isManager',
      'invitations',
      'hasValidBilling',
      'looseReceipts',
      'myCard',
      'myExpenses',
      'myTeam',
      'myTeamWithCards',
      'noOfUnclassifiedTransactions',
    ])
  },
  data () {
    return {
      links: {
        budget: '/budget',
        budgets: '/budgets',
        budgetTransfer: '/budget-transfer',
        cardTransfer: '/card-transfer',
        categories: '/categories',
        company: '/company',
        help: '/help',
        login: '/login',
        logout: '/logout',
        manageRequests: '/manage-requests',
        manageTags: '/manage-tags',
        makeRequest: '/make-request',
        myCard: '/my-card',
        myRequests: '/my-requests',
        profile: '/profile',
        report: '/report',
        request: '/request',
        root: '/',
        settings: '/settings',
        spend: '/spend',
        topUpCard: '/top-up-card',
        transaction: '/transaction',
        user: '/user',
        users: '/users'
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '£', //TODO: get from budget pot / card (company settings)
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  filters: {
    iconColor (req) {
      return req.status === 'declined' ? 'pink' : 'blue'
    },
    listIcon (req) {
      return req.wasRefunded ? 'undo' : (req.status === 'approved' ? 'checkmark_circle_fill' : 'xmark_circle_fill')
    },
    toDate (timestamp) {
      return moment(timestamp).format('DD MMM YYYY')
    },
    toDateTime (timestamp) {
      return moment(timestamp).format('DD MMM YYYY, HH:mm')
    },
    toWeekDate (timestamp) {
      return moment(timestamp).format('dddd, DD MMM YYYY')
    },
    toDayTime (timestamp) {
      return moment(timestamp).format('HH:mm')
    },
    userName (user) {
      return user ? user.firstName + ' ' + user.lastName : ''
    }
  },
  methods: {
    currencySymbol: isoCurrency => {
      switch (isoCurrency) {
        case 'GBP':
          return '£'
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'AUD':
          return 'A$'
        case 'NZD':
          return 'NZ$'
        case 'DKK':
        case 'NOK':
        case 'SEK':
          return 'kr'
        default:
          return isoCurrency
      }
    },
    formatMoney (currency, amount) {
      return !isNaN(amount) ? amount.toLocaleString(localStorage.aio_locale, {
        style: 'currency',
        currency: currency
      }) : ''
    },
    goBack () {
      this.$f7router ? this.$f7router.back() : this.$f7.views.main.router.back()
    },
    isLoggedIn () {
      return localStorage.levima_api_key
    },
    onApiError (error) {
      let msg = ''
      if (error.response) msg = error.response.data
      else if (error.request) msg = 'Couldn\'t connect to server. Please check your connection.'
      else msg = error.message
      this.$f7.dialog.alert(msg, 'Error')
    },
    sortExpenses (expenseA, expenseB) {
      if (expenseA.date < expenseB.date) return 1
      else if (expenseA.date > expenseB.date) return -1
      else return 0
    },
    toDate (timestamp) {
      return this.$options.filters.toDate(timestamp)
    },
    toDateTime (timestamp) {
      return this.$options.filters.toDateTime(timestamp)
    },
    userName (user) {
      return this.$options.filters.userName(user)
    }
  }
}
